import axios from 'axios'

import { authorizationCheck } from './auth.service'

const { REACT_APP_EM_API_URL } = process.env

export const getActivityCodeById = async (id: string): Promise<string> => {
	if (process.env.NODE_ENV !== 'production') {
		return await '1234567' // recognizable default when testing
	} else {
		try {
			const { data, status } = await axios.get(`${REACT_APP_EM_API_URL}/activities/${id}/code` || '/')
			authorizationCheck(status)
			return data.code
		} catch (err) {
			throw Error(err as any)
		}
	}
}
